import { patientQueueApi } from '../api/patient-queue'

export const { useGetPatientQueueByStaffQuery, useAddPatientToQueueMutation, useRemovePatientFromQueueMutation, useReorderQueuedPatientsMutation } =
  patientQueueApi
